import $ from "jquery";

export default function () {
    var video = document.getElementById("hero-video");
    var videoButton = document.getElementById("hero-video-button");
    var videoRestart = document.getElementById("hero-video-button-restart");
    var toggles = document.querySelectorAll(".video-button");

    $(videoButton).on("click", function (e) {
        video.muted = !video.muted;
        $(toggles).toggleClass("visable");
    });

    $(videoRestart).on("click", function (e) {
        video.currentTime = 0;
    });


}
